import React from 'react';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';

import { constants, DateService } from '@atlas/core';
import { Label } from '@atlas/ui';

import eventShape from 'common/PropTypes/eventShape';
import EventLiveStatus from 'common/Widgets/Tournament/Tournament/Events/Event/EventLiveStatus';

import MatchClock from './MatchClock';

const LONG_STATUSES = ['NSY', 'Break Time'];

const TimeStatus = ({ event, withFavorites }) => {
  const {
    info: {
      score: { liveStatus, matchClock, shortLiveStatus },
    },
    sportService,
    startTime,
  } = event;

  dayjs.extend(calendar);
  const isLongStatus = LONG_STATUSES.includes(liveStatus);

  if (sportService === constants.SPORT_SERVICE.PREMATCH) {
    if (startTime) {
      const isToday = dayjs(startTime).calendar(null, { sameDay: '[today]' }) === 'today';
      const formattedDate = DateService.getFormattedDate(startTime);
      const formattedTime = DateService.getFormattedTime(startTime);

      if (withFavorites) {
        return (
          <div className="simple-event-additional-info">
            {isToday ? <Label message="today" /> : <span>{formattedDate}</span>}
            <span>{formattedTime}</span>
          </div>
        );
      }

      return (
        <>
          <span>{formattedTime}</span>
          {isToday ? <Label message="today" /> : <span>{formattedDate}</span>}
        </>
      );
    }

    return null;
  }
  if (isLongStatus) {
    return <Label message={liveStatus} />;
  }

  if (withFavorites) {
    return <EventLiveStatus className="simple-event-additional-info" />;
  }

  return (
    <>
      <span>{shortLiveStatus || liveStatus}</span>
      {matchClock && <MatchClock matchClock={matchClock} withSeconds />}
    </>
  );
};

TimeStatus.propTypes = {
  event: eventShape.isRequired,
};

export default TimeStatus;
